/*
 *
 * DisputeDownloadModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 15-May-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.disputeUci.downloadModal.title'
      defaultMessage='Scarica tutte le pratiche'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.disputeUci.downloadModal.description'
      defaultMessage='Seleziona il formato di file che preferisci'
    />
  ),
  downloadCSV: (
    <PortalMessage
      id='t.app.disputeUci.downloadModal.downloadCSV'
      defaultMessage='Scarica CSV'
    />
  ),
  downloadXLS: (
    <PortalMessage
      id='t.app.disputeUci.downloadModal.downloadXLS'
      defaultMessage='Scarica XLS'
    />
  )
}

export default formattedMessage
